import React from 'react';
import { Tag, Text, ThemeMode, useThemeMode } from '@amzn/storm-ui';
import { getBreadcrumbLabel } from './breadcrumbsHelper';

export const TextBreadcrumb = ({ breadcrumb }) => {
  const { themeMode } = useThemeMode();

  return (
    <Text inline color={themeMode === ThemeMode.DARK ? 'default' : 'inverted'}>
      {getBreadcrumbLabel(breadcrumb)}
      {breadcrumb.objectSuffix && (
        <Tag variant="beta" label={breadcrumb.objectSuffix} />
      )}
    </Text>
  );
};
